/** `42432` — *delete item* (static recipe `17` → `223025 → 42432`, confirmed by the catalogue). */
import { z } from 'zod';
import { defineAction } from '../block.js';
export const deleteItemParams = z.object({});
export const deleteItemAction = defineAction({
    id: '42432',
    kind: 'action',
    app: 'monday',
    sentencePartial: 'delete item',
    paramsSchema: deleteItemParams,
    executable: true,
    references: () => [],
    async execute(context) {
        if (context.itemId === null)
            return { skipped: 'no_item' };
        const item = await context.services.getItem(context.itemId);
        if (item === null)
            return { skipped: 'item_deleted' };
        await context.services.deleteItem(context.itemId);
        return { itemId: context.itemId, deleted: true };
    },
});
//# sourceMappingURL=42432.js.map